import React from 'react';
import './App.scss';

import Routes from './routes/routes'

const App = () =>  <Routes />;

export default App;
